import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './workplace/plugins'
import Rails from '@rails/ujs'
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
window.bootstrap = bootstrap
window.logFirebaseEvent = window.logFirebaseEvent || function() {}

import Turbolinks from 'turbolinks'
import './workplace/application'
import '../javascripts/workplace/form/_audio_output_player'
import '../javascripts/workplace/shared/modals/_df_media_modal'

import '../stylesheets/workplace/workplace.scss'
import './pages/registration.coffee'

Rails.start()
Turbolinks.start()

if (gon.is_analytics_allowed) {
    import('./workplace/firebase/fireinit')
}

if (gon.uxcam_api_key) {
    import('./shared/uxcam-init')
}

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

window.Rails = Rails
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './workplace/plugins'
import Rails from '@rails/ujs'
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
window.bootstrap = bootstrap
window.logFirebaseEvent = window.logFirebaseEvent || function() {}

import Turbolinks from 'turbolinks'
import './workplace/application'
import '../javascripts/workplace/form/_audio_output_player'
import '../javascripts/workplace/shared/modals/_df_media_modal'

import '../stylesheets/workplace/workplace.scss'
import './pages/registration.coffee'

Rails.start()
Turbolinks.start()

if (gon.is_analytics_allowed) {
    import('./workplace/firebase/fireinit')
}

if (gon.uxcam_api_key) {
    import('./shared/uxcam-init')
}

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

window.Rails = Rails
